/** @format */
import { DestroyRef, Injectable, inject } from '@angular/core';
import { inventoryFetched, inventoryFetchErrored } from '@pdp/data-access/state';

import { ISkuLocation } from '@shared/data-access/interfaces';
import { Store as NGRXStore } from '@ngrx/store';
import { StoreService } from '@shared/data-access/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
	providedIn: 'root'
})
export class ProductSelectionInventoryService {
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		private storeService: StoreService,
		private ngrxStore: NGRXStore
	) {}

	setInventoryResultsToState(bopisLocation: number | string, skuIdList: string[]) {
		const shipToMeLocation = 0;

		// Store list to get inventory for
		const storeList = [];

		// Add location "0" to the list (STH)
		storeList.push(shipToMeLocation);

		// Check to see if the BOPIS location is defined
		if (typeof bopisLocation === 'number') {
			storeList.push(bopisLocation);
		}

		this.storeService
			.getSkuInventoryByLocation$(skuIdList, storeList, 1)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: (res: ISkuLocation[]) => {
					// Store Number of '0' is passed to method in order to get available to ship products from eComm inventory
					const shipToMeInventoryMap = this.storeService.filterResults(
						res,
						shipToMeLocation
					);

					// Attempt to get the filtered results for BOPIS...if BOPIS location is undefined then an empty Array will be set
					const bopisLocationInventoryMap = this.storeService.filterResults(
						res,
						bopisLocation
					);

					this.ngrxStore.dispatch(
						inventoryFetched({
							ecommInventory: shipToMeInventoryMap,
							bopisInventory: bopisLocationInventoryMap
						})
					);
				},
				error: () => {
					this.ngrxStore.dispatch(inventoryFetchErrored());
				}
			});
	}
}
